import React from 'react';
import PropTypes from 'prop-types';

import {
  ExtendedBox,
  Box,
  ExtendedFlex,
  Heading,
  Body,
  VisibilitySensor,
} from '../../../coreui';

import DynamicBrowseJoinLink from '../../../helpers';

import backgroundImage from '../../../assets/HP_more_boat.jpg';
import FadeIn from '../../../components/FadeIn';

const InvestmentPlatformSection1 = ({
  isLoggedIn,
  handleSensorChange,
  isVisible,
}) => {
  return (
    <Box
      width={[1, 1, 0.5, 0.5, 0.5]}
    >
      <ExtendedBox
        w={1}
        bgRepeat="no-repeat"
        bgImage={backgroundImage}
        bgPosition="50% 26%"
        bgSize="cover"
      >
        <Box
          w={1}
          px={['15%', '25%', '10%', '10%', '10%']}
        >
          <ExtendedFlex
            flexDirection="column"
            align={['center', 'center', 'flex-end', 'flex-end', 'flex-end']}
          >
            <ExtendedFlex
              maxWidth={['100%', '100%', 400, 400, 540]}
              flexDirection="column"
              my={[60, 60, 100, 100, 100]}
            >
              <FadeIn>
                <Heading
                  type="H2"
                  color="white"
                  m={0}
                  mb="1em"
                  opacity={isVisible ? '1' : '0'}
                >
                  You Deserve More Than Just an Investment Platform.
                </Heading>
              </FadeIn>
              <VisibilitySensor
                callback={handleSensorChange}
              />
              <FadeIn
                fadeInIndex={2}
              >
                <Body
                  type="B1"
                  color="white"
                  fontWeight="light"
                  mb={[200, 200, 360, 360, 440]}
                  opacity={isVisible ? '1' : '0'}
                >
                  Join RealtyMogul and Navigate Through Uncertain Markets.
                </Body>
                <ExtendedBox
                  opacity={isVisible ? '1' : '0'}
                >
                  <DynamicBrowseJoinLink
                    isLoggedIn={isLoggedIn}
                    type="L1"
                  />
                </ExtendedBox>
              </FadeIn>
            </ExtendedFlex>
          </ExtendedFlex>
        </Box>
      </ExtendedBox>
    </Box>
  );
};

InvestmentPlatformSection1.propTypes = {
  isLoggedIn: PropTypes.bool,
  handleSensorChange: PropTypes.func,
  isVisible: PropTypes.bool,
};

export default InvestmentPlatformSection1;
